import { UserRoles } from '../../../../../types/models/user/user.types';
import { FormItem } from '../../../Form/Form.types';
import { ChooseRegisterModalFormSchema } from './ChooseRegisterModalForm.types';

export const chooseRegisterData: FormItem<ChooseRegisterModalFormSchema>[][] = [
  [
    {
      name: 'userType',
      placeholder: 'Choisir une proposition',
      type: 'select',
      options: [
        {
          value: UserRoles.AcheteurPublic,
          label: 'Acheteur public',
        },
        {
          value: UserRoles.Entreprise,
          label: 'Entreprise',
        },
      ],
      required: true,
      id: 'register-type-select',
    },
  ],
];
